export enum MobileHeaderLayout {
  Floating = 'floating',
  Inline = 'inline',
}

export const PAGE_SCAFFOLD_MOBILE_HEADER_HEIGHT = 76;
export const PAGE_SCAFFOLD_DEFAULT_MOBILE_TOP_OFFSET = 72;
